import actions from "./actions";

const {
  CATEGORY_DATA_BEGIN,
  CATEGORY_DATA_SUCCESS,
  CATEGORY_DATA_ERR,
  BRAND_DATA_BEGIN,
  BRAND_DATA_SUCCESS,
  BRAND_DATA_ERR,
  STORE_LIST_DATA_BEGIN,
  STORE_LIST_DATA_SUCCESS,
  STORE_LIST_DATA_ERR,
  STORE_PINCODE_DATA_BEGIN,
  STORE_PINCODE_DATA_SUCCESS,
  STORE_PINCODE_DATA_ERR,
  STORE_PINCODE_DATA_RESET,
  MODEL_LIST_DATA_BEGIN,
  MODEL_LIST_DATA_SUCCESS,
  MODEL_LIST_DATA_ERR,
  STOCK_EMPLOYEE_LIST_DATA_BEGIN,
  STOCK_EMPLOYEE_LIST_DATA_SUCCESS,
  STOCK_EMPLOYEE_LIST_DATA_ERR,
  MAINTENANCE_EMPLOYEE_LIST_DATA_BEGIN,
  MAINTENANCE_EMPLOYEE_LIST_DATA_SUCCESS,
  MAINTENANCE_EMPLOYEE_LIST_DATA_ERR,
  VENDOR_EMPLOYEE_LIST_DATA_BEGIN,
  VENDOR_EMPLOYEE_LIST_DATA_SUCCESS,
  VENDOR_EMPLOYEE_LIST_DATA_ERR,
  STATE_LIST_DATA_BEGIN,
  STATE_LIST_DATA_SUCCESS,
  STATE_LIST_DATA_ERR,
  LANGUAGE_LIST_DATA_BEGIN,
  LANGUAGE_LIST_DATA_SUCCESS,
  LANGUAGE_LIST_DATA_ERR,
  PRODUCT_TYPE_BEGIN,
  PRODUCT_TYPE_SUCCESS,
  PRODUCT_TYPE_ERR,
  MODEL_BEGIN,
  MODEL_SUCCESS,
  MODEL_ERR,
  PAYMENT_BEGIN,
  PAYMENT_SUCCESS,
  PAYMENT_ERR,
  BRAND_BEGIN,
  BRAND_SUCCESS,
  BRAND_ERR,
  EMPLOYEE_DETAIL_BEGIN,
  EMPLOYEE_DETAIL_SUCCESS,
  EMPLOYEE_DETAIL_ERR,
  EMPLOYEE_DETAIL_RESET,
  EMPLOYEE_LIST_BEGIN,
  EMPLOYEE_LIST_SUCCESS,
  EMPLOYEE_LIST_ERR,
  EXCHANGE_MODEL_BEGIN,
  EXCHANGE_MODEL_SUCCESS,
  EXCHANGE_MODEL_ERR,
  APEX_TRADE_MODEL_LIST_BEGIN,
  APEX_TRADE_MODEL_LIST_SUCCESS,
  APEX_TRADE_MODEL_LIST_ERR,
  TRADE_MODEL_LIST_BEGIN,
  TRADE_MODEL_LIST_SUCCESS,
  TRADE_MODEL_LIST_ERR,
  COMMON_FILE_UPLOAD_BEGIN,
  COMMON_FILE_UPLOAD_SUCCESS,
  COMMON_FILE_UPLOAD_ERR,
  COMMON_FILE_UPLOAD_RESET,
} = actions;

const initialStateFilter = { data: "", loading: false, error: null };

const initialFileUploadState = {};

const categoryReducers = (state = initialStateFilter, action) => {
  const { type, data, err } = action;
  switch (type) {
    case CATEGORY_DATA_BEGIN:
      return {
        ...initialStateFilter,
        loading: true,
      };
    case CATEGORY_DATA_SUCCESS:
      return {
        ...initialStateFilter,
        data,
        error: null,
        loading: false,
      };
    case CATEGORY_DATA_ERR:
      return {
        ...initialStateFilter,
        error: err,
        data: null,
        loading: false,
      };

    default:
      return state;
  }
};

const brandReducers = (state = initialStateFilter, action) => {
  const { type, data, err } = action;
  switch (type) {
    case BRAND_DATA_BEGIN:
      return {
        ...initialStateFilter,
        loading: true,
      };
    case BRAND_DATA_SUCCESS:
      return {
        ...initialStateFilter,
        data,
        error: null,
        loading: false,
      };
    case BRAND_DATA_ERR:
      return {
        ...initialStateFilter,
        error: err,
        data: null,
        loading: false,
      };

    default:
      return state;
  }
};

const branchReducers = (state = initialStateFilter, action) => {
  const { type, data, err } = action;
  switch (type) {
    case STORE_LIST_DATA_BEGIN:
      return {
        ...initialStateFilter,
        loading: true,
      };
    case STORE_LIST_DATA_SUCCESS:
      return {
        ...initialStateFilter,
        data,
        error: null,
        loading: false,
      };
    case STORE_LIST_DATA_ERR:
      return {
        ...initialStateFilter,
        error: err,
        data: null,
        loading: false,
      };

    default:
      return state;
  }
};

const storeListPincodeReducers = (state = initialStateFilter, action) => {
  const { type, data, err } = action;
  switch (type) {
    case STORE_PINCODE_DATA_BEGIN:
      return {
        ...initialStateFilter,
        loading: true,
      };
    case STORE_PINCODE_DATA_SUCCESS:
      return {
        ...initialStateFilter,
        data,
        error: null,
        loading: false,
      };
    case STORE_PINCODE_DATA_ERR:
      return {
        ...initialStateFilter,
        error: err,
        data: null,
        loading: false,
      };
    case STORE_PINCODE_DATA_RESET:
      return {
        ...initialStateFilter,
        data: null,
      };
    default:
      return state;
  }
};

const categoryBrandModelReducers = (state = initialStateFilter, action) => {
  const { type, data, err } = action;
  switch (type) {
    case MODEL_LIST_DATA_BEGIN:
      return {
        ...initialStateFilter,
        loading: true,
      };
    case MODEL_LIST_DATA_SUCCESS:
      return {
        ...initialStateFilter,
        data,
        error: null,
        loading: false,
      };
    case MODEL_LIST_DATA_ERR:
      return {
        ...initialStateFilter,
        error: err,
        data: null,
        loading: false,
      };

    default:
      return state;
  }
};

const stockEmployeeListReducers = (state = initialStateFilter, action) => {
  const { type, data, err } = action;
  switch (type) {
    case STOCK_EMPLOYEE_LIST_DATA_BEGIN:
      return {
        ...initialStateFilter,
        loading: true,
      };
    case STOCK_EMPLOYEE_LIST_DATA_SUCCESS:
      return {
        ...initialStateFilter,
        data,
        error: null,
        loading: false,
      };
    case STOCK_EMPLOYEE_LIST_DATA_ERR:
      return {
        ...initialStateFilter,
        error: err,
        data: null,
        loading: false,
      };

    default:
      return state;
  }
};

const maintenanceEmployeeListReducers = (
  state = initialStateFilter,
  action
) => {
  const { type, data, err } = action;
  switch (type) {
    case MAINTENANCE_EMPLOYEE_LIST_DATA_BEGIN:
      return {
        ...initialStateFilter,
        loading: true,
      };
    case MAINTENANCE_EMPLOYEE_LIST_DATA_SUCCESS:
      return {
        ...initialStateFilter,
        data,
        error: null,
        loading: false,
      };
    case MAINTENANCE_EMPLOYEE_LIST_DATA_ERR:
      return {
        ...initialStateFilter,
        error: err,
        data: null,
        loading: false,
      };

    default:
      return state;
  }
};

const vendorEmployeeListReducers = (state = initialStateFilter, action) => {
  const { type, data, err } = action;
  switch (type) {
    case VENDOR_EMPLOYEE_LIST_DATA_BEGIN:
      return {
        ...initialStateFilter,
        loading: true,
      };
    case VENDOR_EMPLOYEE_LIST_DATA_SUCCESS:
      return {
        ...initialStateFilter,
        data,
        error: null,
        loading: false,
      };
    case VENDOR_EMPLOYEE_LIST_DATA_ERR:
      return {
        ...initialStateFilter,
        error: err,
        data: null,
        loading: false,
      };

    default:
      return state;
  }
};

const stateListReducers = (state = initialStateFilter, action) => {
  const { type, data, err } = action;
  switch (type) {
    case STATE_LIST_DATA_BEGIN:
      return {
        ...initialStateFilter,
        loading: true,
      };
    case STATE_LIST_DATA_SUCCESS:
      return {
        ...initialStateFilter,
        data,
        error: null,
        loading: false,
      };
    case STATE_LIST_DATA_ERR:
      return {
        ...initialStateFilter,
        error: err,
        data: null,
        loading: false,
      };

    default:
      return state;
  }
};

const languageListReducers = (state = initialStateFilter, action) => {
  const { type, data, err } = action;
  switch (type) {
    case LANGUAGE_LIST_DATA_BEGIN:
      return {
        ...initialStateFilter,
        loading: true,
      };
    case LANGUAGE_LIST_DATA_SUCCESS:
      return {
        ...initialStateFilter,
        data,
        error: null,
        loading: false,
      };
    case LANGUAGE_LIST_DATA_ERR:
      return {
        ...initialStateFilter,
        error: err,
        data: null,
        loading: false,
      };

    default:
      return state;
  }
};

export const productTypeReducers = (state = initialStateFilter, action) => {
  const { type, data, err } = action;
  switch (type) {
    case PRODUCT_TYPE_BEGIN:
      return {
        ...initialStateFilter,
        loading: true,
      };
    case PRODUCT_TYPE_SUCCESS:
      return {
        ...initialStateFilter,
        data,
        error: null,
        loading: false,
      };
    case PRODUCT_TYPE_ERR:
      return {
        ...initialStateFilter,
        error: err,
        data: null,
        loading: false,
      };
    default:
      return state;
  }
};

export const getBrandReducers = (state = initialStateFilter, action) => {
  const { type, data, err } = action;
  switch (type) {
    case BRAND_BEGIN:
      return {
        ...initialStateFilter,
        loading: true,
      };
    case BRAND_SUCCESS:
      return {
        ...initialStateFilter,
        data,
        error: null,
        loading: false,
      };
    case BRAND_ERR:
      return {
        ...initialStateFilter,
        error: err,
        data: null,
        loading: false,
      };
    default:
      return state;
  }
};

export const getModelReducers = (state = initialStateFilter, action) => {
  const { type, data, err } = action;
  switch (type) {
    case MODEL_BEGIN:
      return {
        ...initialStateFilter,
        loading: true,
      };
    case MODEL_SUCCESS:
      return {
        ...initialStateFilter,
        data,
        error: null,
        loading: false,
      };
    case MODEL_ERR:
      return {
        ...initialStateFilter,
        error: err,
        data: null,
        loading: false,
      };
    default:
      return state;
  }
};

export const getPaymentReducers = (state = initialStateFilter, action) => {
  const { type, data, err } = action;
  switch (type) {
    case PAYMENT_BEGIN:
      return {
        ...initialStateFilter,
        loading: true,
      };
    case PAYMENT_SUCCESS:
      return {
        ...initialStateFilter,
        data,
        error: null,
        loading: false,
      };
    case PAYMENT_ERR:
      return {
        ...initialStateFilter,
        error: err,
        data: null,
        loading: false,
      };
    default:
      return state;
  }
};

export const getEmployeeDetailReducers = (
  state = initialStateFilter,
  action
) => {
  const { type, data, err } = action;
  switch (type) {
    case EMPLOYEE_DETAIL_BEGIN:
      return {
        ...initialStateFilter,
        loading: true,
      };
    case EMPLOYEE_DETAIL_SUCCESS:
      return {
        ...initialStateFilter,
        data,
        error: null,
        loading: false,
      };
    case EMPLOYEE_DETAIL_ERR:
      return {
        ...initialStateFilter,
        error: err,
        data: null,
        loading: false,
      };
    case EMPLOYEE_DETAIL_RESET:
      return initialStateFilter;
    default:
      return state;
  }
};

export const getEmployeeListReducers = (
  state = initialStateFilter,
  action
) => {
  const { type, data, err } = action;
  switch (type) {
    case EMPLOYEE_LIST_BEGIN:
      return {
        ...initialStateFilter,
        loading: true,
      };
    case EMPLOYEE_LIST_SUCCESS:
      return {
        ...initialStateFilter,
        data,
        error: null,
        loading: false,
      };
    case EMPLOYEE_LIST_ERR:
      return {
        ...initialStateFilter,
        error: err,
        data: null,
        loading: false,
      };
    default:
      return state;
  }
};
export const exchangeModelDetailReducer = (
  state = initialStateFilter,
  action
) => {
  const { type, data, err } = action;
  switch (type) {
    case EXCHANGE_MODEL_BEGIN:
      return {
        ...initialStateFilter,
        loading: true,
      };
    case EXCHANGE_MODEL_SUCCESS:
      return {
        ...initialStateFilter,
        data,
        loading: false,
        error: null,
      };
    case EXCHANGE_MODEL_ERR:
      return {
        ...initialStateFilter,
        error: err,
        data: null,
        loading: false,
      };
    default:
      return state;
  }
};

export const apexTradeModelListReducer = (
  state = initialStateFilter,
  action
) => {
  const { type, data, err } = action;
  switch (type) {
    case APEX_TRADE_MODEL_LIST_BEGIN:
      return {
        ...initialStateFilter,
        loading: true,
      };
    case APEX_TRADE_MODEL_LIST_SUCCESS:
      return {
        ...initialStateFilter,
        data,
        error: null,
        loading: false,
      };
    case APEX_TRADE_MODEL_LIST_ERR:
      return {
        ...initialStateFilter,
        error: err,
        data: null,
        loading: false,
      };
    default:
      return state;
  }
};

export const tradeModelListReducer = (state = initialStateFilter, action) => {
  const { type, data, err } = action;
  switch (type) {
    case TRADE_MODEL_LIST_BEGIN:
      return {
        ...initialStateFilter,
        loading: true,
      };
    case TRADE_MODEL_LIST_SUCCESS:
      return {
        ...initialStateFilter,
        data,
        error: null,
        loading: false,
      };
    case TRADE_MODEL_LIST_ERR:
      return {
        ...initialStateFilter,
        error: err,
        data: null,
        loading: false,
      };
    default:
      return state;
  }
};

export const commonFileUploadReducer = (state = initialFileUploadState, action) => {
  const { type, data, err, fileType } = action;
  switch (type) {
    case COMMON_FILE_UPLOAD_BEGIN:
      return {
        ...state,
        [fileType]: { data: null, loading: true, error: null },
      };
    case COMMON_FILE_UPLOAD_SUCCESS:
      return {
        ...state,
        [fileType]: { data, loading: false, error: null },
      };
    case COMMON_FILE_UPLOAD_ERR:
      return {
        ...state,
        [fileType]: { data: null, loading: false, error: err },
      };
    case COMMON_FILE_UPLOAD_RESET:
      return initialFileUploadState;
    default:
      return state;
  }
};

export {
  categoryReducers,
  brandReducers,
  branchReducers,
  storeListPincodeReducers,
  categoryBrandModelReducers,
  stockEmployeeListReducers,
  maintenanceEmployeeListReducers,
  vendorEmployeeListReducers,
  stateListReducers,
  languageListReducers,
};
